import type { IconData } from '@stacksjs/iconify-core'

export const gg4x3: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h640v480H0z\"/><path fill=\"#e8112d\" d=\"M256 0h128v480H256z\"/><path fill=\"#e8112d\" d=\"M0 176h640v128H0z\"/><path id=\"SVGiTRpoaev\" fill=\"#f9dd16\" d=\"m110 286.7l23.3-23.4h210v-46.6h-210L110 193.3z\"/><use width=\"36\" height=\"24\" href=\"#SVGiTRpoaev\" transform=\"rotate(90 320 240)\"/><use width=\"36\" height=\"24\" href=\"#SVGiTRpoaev\" transform=\"rotate(-90 320 240)\"/><use width=\"36\" height=\"24\" href=\"#SVGiTRpoaev\" transform=\"rotate(180 320 240)\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default gg4x3
